<script setup lang="ts">
  import { cva } from 'class-variance-authority'
  import { marked } from 'marked'

  const props = withDefaults(
    defineProps<{
      blok: any
      compact?: boolean
    }>(),
    {
      compact: false
    }
  )

  const output = computed(() => marked(props.blok.content))

  const cardBase = computed(() =>
    cva('flex overflow-hidden flex-col', {
      variants: {
        compact: {
          true: '',
          false: 'md:col-span-3'
        }
      }
    })({
      compact: props.compact
    })
  )
</script>

<template>
  <div
    v-editable="blok"
    :class="cardBase"
  >
    <div class="size-full rounded-sm bg-neutral-50 px-4 pb-10 pt-6">
      <div
        class="[&_a]:text-inherit"
        v-html="output"
      />
    </div>
  </div>
</template>
